import PropTypes from 'prop-types'
import React, { Component } from 'react'
import classnames from 'classnames'

import Icon from './Icon'

const FloatingPlaceholderGroup = class FloatingPlaceholderGroup extends Component {
  constructor (props) {
    super(props)
    this.state = {
      active: !!props.defaultValue
    }
    this.handleBlur = this.handleBlur.bind(this)
    this.handleFocus = this.handleFocus.bind(this)
  }
  handleBlur (e) {
    if (e.target.value.length) {
      this.setState({ active: true })
    }
  }
  handleFocus (e) {
    if (this.state.active) {
      this.setState({ active: false })
    }
  }
  render () {
    const { active } = this.state
    const {
      defaultValue,
      label,
      InputComponent,
      inputName,
      inputType,
      inputPattern,
      refFn,
      error,
      required
    } = this.props
    const classes = classnames(
      {
        'floating-placeholder--active': active,
        'floating-placeholder--error': error
      },
      'floating-placeholder'
    )

    return (
      <div className={classes}>
        <InputComponent
          name={inputName}
          type={inputType}
          pattern={inputPattern}
          defaultValue={defaultValue}
          required={required}
          onBlur={this.handleBlur}
          onFocus={this.handleFocus}
          rows='3' // for textareas
          ref={refFn}
          className='pl2 floating-placeholder__input full-width mb1'
        />
        {/* NOTE: this onClick on the label is needed for Internet Explorer,
            where `pointer-events:none` (set in CSS) has no effect on non SVG elements
        */}
        <label
          className='floating-placeholder__label'
          onClick={() => {
            this._inputEl.focus()
          }}
        >
          {error && (
            <Icon
              icon='notification'
              className='icon floating-placeholder__label-icon'
            />
          )}
          {label}
          {required && ' *'}
        </label>
      </div>
    )
  }
}

FloatingPlaceholderGroup.propTypes = {
  defaultValue: PropTypes.string,
  label: PropTypes.string.isRequired,
  InputComponent: PropTypes.string.isRequired,
  inputName: PropTypes.string,
  inputType: PropTypes.string,
  inputPattern: PropTypes.string,
  error: PropTypes.bool,
  required: PropTypes.bool,
  refFn: PropTypes.func
}

FloatingPlaceholderGroup.defaultProps = {
  InputComponent: 'input'
}

export default FloatingPlaceholderGroup



// WEBPACK FOOTER //
// ./frontend/scripts/react/components/FloatingPlaceholderGroup.js